export default {
    methods: {
        showLoader() {
            this.loader = this.$loading.show({
                container: this.$refs.loadingContainer, //full page
                onCancel: false, // can't cancel
                loader: "dots", // 'spinner' , 'dots' or 'bars',
                opacity: 0.75,
                backgroundColor: "#000000",
                color: "#475fb3",
                zIndex: 999,
            });
        },
        hideLoader() {
            this.loader.hide();
        }
    }
}